import { NoImage } from "@assets/constant/index.constant";
import { Switch } from "@components/ui/switch";
import { endpoint } from "@services/api.services";
import { formatDateTime } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";
import { NavLink } from "react-router";

const ColumnList = ({
  refetch,
  toggleActiveStatus,
}: {
  refetch?: () => void;
  toggleActiveStatus: (id: string | number, state: boolean) => void;
}) => {
  const CherishMomentEndpoint = useMemo(
    () => endpoint["enterprise-cherish-moments"],
    []
  );
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: CherishMomentEndpoint,
    refetch,
  });

  const columns = useMemo(
    () => [
      {
        name: "ID",
        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Created Date",
        accessKey: "created_at",
        cell: (row: any) => {
          const date = row.updated_at || row.updated_date || row.created_at || row.created_date;
          return (
            <span className="font-semibold text-gray-700">
              {date ? formatDateTime(date) : "-"}
            </span>
          );
        },
        sortable: true,
      },
      {
        name: "Image",
        cell: (row: any) => (
          <img
            src={row.image_link || NoImage}
            alt={row.title}
            className="w-[60px] h-[40px] object-cover rounded"
          />
        ),
        sortable: false,
      },
      {
        name: "Title",
        cell: (row: any) => (
          <span className="font-semibold text-gray-700 max-w-[200px] truncate block">
            {row.title}
          </span>
        ),
        sortable: true,
      },
      {
        name: "Sub Text",
        cell: (row: any) => (
          <p className="line-clamp-2 max-w-[300px] w-fit text-gray-600">
            {row.sub_text}
          </p>
        ),
        sortable: false,
      },
      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <Switch
              defaultChecked={row?.is_show}
              onCheckedChange={(value) => toggleActiveStatus(row?.id, value)}
              className="cursor-pointer"
            />
            <NavLink
              to={`/enterprise-cherish-moments?page=edit&page-item=${row.id}`}
            >
              <button
                className="text-[#1DA077] cursor-pointer"
                title="Edit"
                type="button"
              >
                Edit
              </button>
            </NavLink>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );

  return columns;
};

export { ColumnList };
